import { render, staticRenderFns } from "./user-index.vue?vue&type=template&id=f63a21e0&"
import script from "./user-index.vue?vue&type=script&lang=ts&"
export * from "./user-index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports